var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48477 0.803411C6.77278 1.09142 6.77278 1.55838 6.48477 1.84639L2.58126 5.7499L6.48477 9.65341C6.77278 9.94142 6.77278 10.4084 6.48477 10.6964C6.19676 10.9844 5.7298 10.9844 5.44179 10.6964L1.01679 6.27139C0.728778 5.98338 0.728778 5.51642 1.01679 5.22841L5.44179 0.803411C5.7298 0.515399 6.19676 0.515399 6.48477 0.803411Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.9e343f5cf4d816b74580fb5475203e35.svg";
export { ForwardRef as ReactComponent };